import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;

    input:focus {
        outline: none;
        border: solid 1px #008eff;
    }
`;

const Input = styled.input`
    height: 36px;
    border-radius: 2px;
    border: solid 1px ${props => (props.touched && props.error ? '#ff245e' : '#f1f1ee')};
    font-family: Averta;
    font-size: 14px;
    line-height: 1.43;
    padding: 0.571em;
    color: ${props =>
        props.touched && props.error
            ? '#ff245e'
            : props.inputColor != null
            ? props.inputColor
            : '#333'};
    -webkit-appearance: none;

    &::placeholder {
        color: #a59f9f;
        font-size: 13px;
    }

    @media (max-width: 30em) {
        margin-left: 0;
        margin-right: 0;
    }
`;

const LabelContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Error = styled.div`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-align: right;
    color: #ff245e;
    text-transform: uppercase;
`;

const Label = styled.label`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 0.5em;
`;

const LabelInfo = Label.extend`
    text-transform: none;
    letter-spacing: 0;
    margin-top: 6px;
    margin-bottom: 0;
    font-weight: 500;
    font-size: 8.5px;
    line-height: 1.4;
`;

class InputGroup extends React.Component {
    constructor(props) {
        super(props);
        this.focusTextInput = this.focusTextInput.bind(this);
    }

    componentDidMount() {
        if (this.props.autoFocus) {
            this.focusTextInput();
        }
    }

    focusTextInput() {
        // timeout is not working on iOS Safari
        // if (this.props.autoFocusTimeout) {
        //   setTimeout(() => {
        //     findDOMNode(this.textInput).focus()
        //   }, this.props.autoFocusTimeout)
        // } else {
        //   findDOMNode(this.textInput).focus()
        // }

        this.textInput.focus();
    }

    render() {
        return (
            <Container className={this.props.class}>
                <LabelContainer>
                    <Label htmlFor="">{this.props.label}</Label>
                    {this.props.meta.touched && this.props.meta.error && (
                        <Error>{this.props.meta.error}</Error>
                    )}
                </LabelContainer>
                <Input
                    {...this.props.input}
                    {...this.props.meta}
                    inputColor={this.props.inputColor}
                    maxLength={this.props.maxLength}
                    placeholder={this.props.placeholder}
                    autoComplete={this.props.autocomplete}
                    size="10"
                    type={this.props.type}
                    innerRef={i => {
                        this.textInput = i;
                    }}
                    readOnly={this.props.readOnly}
                />
                {this.props.infoText && <LabelInfo>{this.props.infoText}</LabelInfo>}
            </Container>
        );
    }
}

InputGroup.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    primary: PropTypes.bool,
    autoFocus: PropTypes.bool,
    maxLength: PropTypes.number,
    autoFocusTimeout: PropTypes.number,
    placeholder: PropTypes.string,
    autocomplete: PropTypes.string,
    inputColor: PropTypes.string,
    readOnly: PropTypes.bool,
    infoText: PropTypes.string,
    class: PropTypes.string
};

export default InputGroup;



// WEBPACK FOOTER //
// ./src/components/InputGroup.jsx